import script from "./DoorSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./DoorSettings.vue?vue&type=script&setup=true&lang=js"

import "./DoorSettings.vue?vue&type=style&index=0&id=5d99f028&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d99f028"]])

export default __exports__